import './detail-login-req';
import 'slick-carousel/slick/slick';
window.rateit = require('jquery.rateit');
let schoolCallBtn = $('#callSchool');

let detailScrollbar = $('#detail-scrollbar');
let detailNavScroll = detailScrollbar.offset().top - detailScrollbar.height();
let headerTopHeight = $('#headerTop').height();
let bottomHeader = $('#headerBottom');

$(function () {
    $("#detail-scrollbar li").each(function() {
        var navLink = $(this).find("a").attr("href");
        var targetNavElement = $(navLink);

        if (targetNavElement.length) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    lightGallery(document.getElementById('gallery-images'), {
        thumbnail: true,
        animateThumb: true,
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        vimeoThumbSize: 'thumbnail_medium',
        youtubePlayerParams: {
            modestbranding: 1,
            showinfo: 0,
            rel: 0,
            controls: 0
        },
        selector: '.hotlink',
        exThumbImage: 'data-exthumbimage'
    });
    schoolCallBtn.click(function () {
        if (!user) {
            $('#loginModal').modal('show', {backdrop: 'static', keyboard: false});
        } else {
            var phoneNum = schoolCallBtn.attr('data-phone');
            schoolCallBtn.attr('href', 'tel:' + phoneNum);
        }
    });

    $('#detail-toggle-login').click(function () {
        $('#loginModal').modal('show');
    });



    $(document).scroll(function () {
        if ($(document).scrollTop() > detailNavScroll) {
            detailScrollbar.css('position', 'fixed');
            detailScrollbar.css('top', headerTopHeight);
            detailScrollbar.css('right', '0');
            detailScrollbar.css('width', '100%');
            detailScrollbar.css('border-radius', '0');
            detailScrollbar.css('z-index', '99');
            detailScrollbar.css('margin-right', '0');
            detailScrollbar.css('padding', '10px 100px');
            bottomHeader.addClass('invisible');
            if (window.matchMedia('(max-width: 992px)').matches) {
                detailScrollbar.css('padding', '');
                bottomHeader.removeClass('invisible');
            }
        } else {
            detailScrollbar.css('position', '');
            detailScrollbar.css('top', '');
            detailScrollbar.css('right', '');
            detailScrollbar.css('width', '');
            detailScrollbar.css('border-radius', '');
            detailScrollbar.css('z-index', '');
            detailScrollbar.css('margin-right', '');
            detailScrollbar.css('padding', '');
            bottomHeader.removeClass('invisible');
        }
    });

    if($("#gradeWiseFee").length == 0) {
        $("#fees").addClass('withoutGradewise');
    }
});

$(".gallery-images").slick({
    dots: true,
    appendArrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

import './detail-view';
import './detail-review';


